<template>
    <div class="text-right small">
        <h6>Last Sync Details</h6>
        <table class="table table-borderless text-caption" style="font-size: 13px !important; line-height: 25px;" v-if="last_syncs">
            <tr>
                <td width="150"><b>Period start</b> :</td>
                <td>{{ last_syncs.period_start }}</td>
            </tr>
            <tr>
                <td width="150"><b>Period end</b> :</td>
                <td>{{ last_syncs.period_end }}</td>
            </tr>
            <tr>
                <td width="150"><b>Records</b> :</td>
                <td>{{ last_syncs.records_found }}</td>
            </tr>
            <tr>
                <td width="150"><b>Status</b> :</td>
                <td><v-chip x-small :color="getColor(last_syncs.sync_status)" :text-color="getTextColor(last_syncs.sync_status)" :style="'border: 1px solid ' + getBorderColor(last_syncs.sync_status)">{{ last_syncs.sync_status }}</v-chip></td>
            </tr>
            <tr>
                <td width="150"><b>Type</b> :</td>
                <td>{{ last_syncs.sync_type }}</td>
            </tr>
            <tr>
                <td width="150"><b>Created at</b> :</td>
                <td>{{ last_syncs.created_at }}</td>
            </tr>
            <tr>
                <td width="150"><b>Updated at</b> :</td>
                <td>{{ last_syncs.updated_at }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        last_syncs: { type: Object, default: {} }
    }
}
</script>